import { VoucherCategory, } from '@debbie/common/dist/economy/vouchers/index.js';
import { useVoucherTypes } from '@debbie/cortex/dist/voucher-types/index.js';
import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ArrowUpRight, Briefcase, CreditCard, FileText, Layers, Percent, Repeat, Tag, } from './Icons/index.js';
import { PALETTE } from './SearchableDropdown.js';
import SearchableSelect from './SearchableSelect.js';
const CATEGORY_ICON = {
    [VoucherCategory.PRINCIPAL]: { icon: React.createElement(FileText, null), palette: PALETTE.accent },
    [VoucherCategory.COST]: { icon: React.createElement(Tag, null), palette: PALETTE.neutral },
    [VoucherCategory.COURTCOST]: {
        icon: React.createElement(Briefcase, null),
        palette: PALETTE.warning,
    },
    [VoucherCategory.INTEREST]: { icon: React.createElement(Percent, null), palette: PALETTE.success },
    [VoucherCategory.TRANSACTION]: {
        icon: React.createElement(CreditCard, null),
        palette: PALETTE.neutral,
    },
    [VoucherCategory.FEE]: { icon: React.createElement(Tag, null), palette: PALETTE.accent },
    [VoucherCategory.DISBURSEMENT]: {
        icon: React.createElement(ArrowUpRight, null),
        palette: PALETTE.warning,
    },
    [VoucherCategory.COLLECTIONCOMMISSION]: {
        icon: React.createElement(Percent, null),
        palette: PALETTE.accent,
    },
    [VoucherCategory.PAYOUT]: {
        icon: React.createElement(ArrowUpRight, null),
        palette: PALETTE.neutral,
    },
    [VoucherCategory.OVERPAYMENT]: { icon: React.createElement(Repeat, null), palette: PALETTE.neutral },
    [VoucherCategory.VAT]: { icon: React.createElement(Layers, null), palette: PALETTE.neutral },
};
const voucherTypeId = (voucherType) => voucherType.voucherTypeId;
const categoryOf = (voucherType) => voucherType.category;
const categoryIcon = (voucherType) => CATEGORY_ICON[voucherType.category];
/**
 * Searchable select over the tenant's voucher types of the given
 * categories, with a chip per category and the category as row description.
 * BillingVoucherTypeSelect and CaseVoucherTypeSelect pick the categories.
 */
const VoucherTypeSelect = ({ categories, ...props }) => {
    const lang = useSelector((s) => s.lang);
    const voucherTypes = useVoucherTypes();
    const { filter } = props;
    // Keyed by content so callers can pass a fresh array each render
    const categoryKey = categories.join(',');
    const selectable = useMemo(() => {
        const included = new Set(categoryKey.split(','));
        return (voucherType) => included.has(voucherType.category) &&
            (filter ? filter(voucherType) : true);
    }, [categoryKey, filter]);
    const label = useCallback((voucherType) => lang.economyVoucherTypeLabels[voucherType.voucherTypeId] ||
        voucherType.label, [lang]);
    // Both the translated and the raw label match a search
    const searchText = useCallback((voucherType) => `${lang.economyVoucherTypeLabels[voucherType.voucherTypeId] || ''} ${voucherType.label}`, [lang]);
    const description = (voucherType) => lang.economyCategories[voucherType.category];
    const facet = useMemo(() => categories.length > 1
        ? {
            of: categoryOf,
            options: categories.map((category) => ({
                key: category,
                label: lang.economyCategories[category],
                icon: CATEGORY_ICON[category].icon,
            })),
            hideEmpty: true,
        }
        : undefined, 
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- categoryKey stands in for categories
    [categoryKey, lang]);
    return (React.createElement(SearchableSelect, { ...props, filter: selectable, items: voucherTypes, getId: voucherTypeId, getLabel: label, getSearchText: searchText, getIcon: categoryIcon, getDescription: description, facet: facet, labels: {
            search: lang.voucherTypeSelect.searchVoucherTypes,
            all: lang.voucherTypeSelect.allVoucherTypes,
        }, recentsStorageKey: `debbie.voucherTypeSelect.${categoryKey}.recentlyUsed` }));
};
export default VoucherTypeSelect;
//# sourceMappingURL=VoucherTypeSelect.js.map